import classNames from "classnames";
import styles from "./ScheduleDrawer.module.scss";

interface ScheduleFormSectionProps {
    title: string;
    icon: React.ReactNode;
    iconClassName: string;
    sectionClassName?: string;
    headerAddon?: React.ReactNode;
    children: React.ReactNode;
}

export function ScheduleFormSection({
    title,
    icon,
    iconClassName,
    sectionClassName,
    headerAddon,
    children,
}: ScheduleFormSectionProps) {
    return (
        <section className={classNames(styles.section, sectionClassName)}>
            <header className={styles.sectionHeader}>
                <div className={styles.sectionHeaderGroup}>
                    <aside
                        className={classNames(
                            styles.sectionIcon,
                            iconClassName,
                        )}
                    >
                        {icon}
                    </aside>
                    <h2 className={styles.sectionTitle}>{title}</h2>
                </div>
                {headerAddon}
            </header>
            <div className={styles.sectionContent}>{children}</div>
        </section>
    );
}
